// @ts-nocheck
import React, { Component } from 'react';
import Select from 'corp/components/UI/Select';
import apiFetch, { defaultApiFetchErrorHandler } from '@scale/frontend-lib/api-fetch';

interface Props {
  fullWidth?: boolean;
}
export default class SelectWorkflow extends Component<Props> {
  async fetchWorkflow(text) {
    try {
      const { workflowType } = this.props;
      const results = await apiFetch(null, `corp-api/${workflowType}`, {
        query: { search: text },
      });
      const options =
        results.workflows?.map(workflow => ({
          label: workflow.name,
          value: workflow._id,
        })) || [];
      return {
        options,
      };
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
      return { options: [] };
    }
  }

  render() {
    const style = this.props.fullWidth ? {} : { display: 'flex', justifyContent: 'flex-end' };
    return (
      <React.Fragment>
        <div style={style}>
          <Select
            filterOption={() => true}
            {...this.props}
            loadOptions={this.fetchWorkflow.bind(this)}
            style={this.props.fullWidth ? {} : { width: '200px' }}
          />
        </div>
      </React.Fragment>
    );
  }
}
